const devHostnames = [
  "kons15.pondoo.ai",
  "omsorg-dev.pondoo.ai",
  "kons14.pondoo.ai",
  "localhost",
];

export const isDevEnvironment = devHostnames.includes(window.location.hostname);

const localDev = ["localhost"];

export const isRulesetSelectorShown = true;

const previewHostnames = [
  "kons15.pondoo.ai",
  "omsorg-dev.pondoo.ai",
  "localhost",
];

export const isPreviewEnvironment = previewHostnames.includes(
  window.location.hostname,
);

const constraintHostnames = [
  "kons14.pondoo.ai",
  "kons15.pondoo.ai",
  "localhost",
  "omsorg-dev.pondoo.ai",
  "viborg.pondoo.ai",
];

export const isConstraintShown = constraintHostnames.includes(
  window.location.hostname,
);

const replanningHostnames = [
  "kons14.pondoo.ai",
  "kons15.pondoo.ai",
  "localhost",
  "omsorg-dev.pondoo.ai",
  "viborg.pondoo.ai",
];

export const isReplanningShown = replanningHostnames.includes(
  window.location.hostname,
);

const calendarSettingsHostnames = ["localhost"];

export const isCalendarSettingsShown = calendarSettingsHostnames.includes(
  window.location.hostname,
);
